/* eslint-disable react/no-danger */
import React, { forwardRef, useRef, useImperativeHandle } from 'react'
import AckodriveTable from '@components/Ackodrive/Table'
import AckodriveFaq from '@components/Ackodrive/faq/collapsible'
import { ComponentTypes } from '@enums/strapiTypesAndOperators'
import styles from './mainContent.module.scss'
import AckodriveRichTextEditor from './AckodriveRichTextEditor'
import AckodriveEmbedHtml from './AckodriveEmbedHtml'

const cheerio = typeof window === 'undefined' ? global.cheerio : window.cheerio

const componentMapping = {
  [ComponentTypes.RichTextCK]: { component: AckodriveRichTextEditor, excludeParentClass: false },
  [ComponentTypes.ReviewsAdEmbedded]: { component: AckodriveEmbedHtml, excludeParentClass: false },
  [ComponentTypes.NewsAdEmbedded]: { component: AckodriveEmbedHtml, excludeParentClass: false },
  [ComponentTypes.BlogAdEmbed]: { component: AckodriveEmbedHtml, excludeParentClass: false },
  [ComponentTypes.BlogAdCollapsible]: { component: AckodriveFaq, excludeParentClass: true },
  [ComponentTypes.BlogAdTC]: { component: AckodriveTable, excludeParentClass: true },
  [ComponentTypes.BlogAdSWC]: { component: AckodriveRichTextEditor, excludeParentClass: false },
}

const MainContentWithRef = ({ data }, ref) => {
  const parentRef = useRef(null)

  useImperativeHandle(ref, () => ({
    parent: () => parentRef.current,
  }))

  const getModifiedHtml = htmlContent => {
    const $ = cheerio.load(htmlContent, null, false)

    $('img').attr('loading', 'lazy')
    $('img').attr('decoding', 'async')
    $('img').each((_, img) => {
      $(img).attr('width', '740')
      $(img).attr('height', '400')
    })

    $('div.raw-html-embed').each((_, element) => {
      const content = $(element).html()
      $(element).html(`<div class="${styles.htmlBaseContentWrapper}">${content}</div>`)
    })

    return $.html()
  }

  return (
    <div id="contentAfterTocComponent" ref={parentRef}>
      {Array.isArray(data) ? (
        data.map((item, index) => {
          const Component = componentMapping[item.__component]?.component
          const excludeParentClass = componentMapping[item.__component]?.excludeParentClass

          if (Component) {
            return (
              <div key={index} className={excludeParentClass ? '' : styles.mainContentWithRef}>
                <Component key={index} content={item.Content} />
              </div>
            )
          }
          return null
        })
      ) : (
        <div className={styles.mainContentWithRef} dangerouslySetInnerHTML={{ __html: getModifiedHtml(data) }} />
      )}
    </div>
  )
}

export default forwardRef(MainContentWithRef)
